<template>
  <a
    v-if="!isHidden && isLink"
    :href="value"
    target="_blank"
    v-show="!isHidden"
  >
    <slot />
  </a>
  <span v-else-if="!isHidden && isBoolean" v-show="!isHidden && !!value">
    <slot />
  </span>
  <div v-else-if="isComponent">
    <slot :data="appData" />
  </div>
  <span v-else-if="!isLink" v-show="!isHidden">
    {{ value }}
  </span>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppDataPropertyComponent',
  components: {},
  props: {
    eventToListen: {
      type: String,
      default: 'app_data_updated',
    },
    contentId: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    isMetaProperty: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: String,
      default: '',
    },
    isLink: {
      type: Boolean,
      default: false,
    },
    isBoolean: {
      type: Boolean,
      default: false,
    },
    isComponent: {
      type: Boolean,
      default: false,
    },
    hideIfEmpty: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      appData: {},
      value: this.defaultValue,
      eventsIds: [],
      appInfoFindingId: 0,
    }
  },
  mounted() {
    this.loadProperty()
    const id = this.$Events.handleEvent(this.eventToListen, this.loadProperty)
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
    this.unsubscribeToAppInfoResponse()
  },
  methods: {
    async loadProperty() {
      if (this.$Commons.isEmpty(this.contentId)) {
        this.value = this.defaultValue
        return
      }

      this.unsubscribeToAppInfoResponse()
      const { unsubscribe } = this.$Events.sendDataRequest(
        this.contentId,
        this.onAppDataGot,
      )
      this.unsubscribeToAppInfoResponse = unsubscribe
    },
    unsubscribeToAppInfoResponse() {},
    onAppDataGot(appData) {
      if (!appData) {
        this.value = this.defaultValue
        return
      }

      this.appData = appData
      this.$emit('dataAvailable', appData)
      if (this.$Commons.isEmpty(this.name)) {
        return
      }

      let value = null
      value = appData[this.name]
      if (this.isMetaProperty || value == undefined || value == null)
        value = (appData?.metaData || {})[this.name]
      if (value == null || value == undefined) value = this.defaultValue
      this.value = value

      this.$forceUpdate()
    },
    isVisible() {
      return !this.isHidden
    },
  },
  watch: {
    _props: {
      deep: true,
      handler() {
        this.loadProperty()
      },
    },
  },
  computed: {
    isHidden() {
      return this.$Commons.isEmpty(this.value) && this.hideIfEmpty
    },
  },
})
</script>
